// extracted by mini-css-extract-plugin
export var margin = "WhyUseAgent--margin--KLaRD";
export var tkMyriadProSemiCondensed = "WhyUseAgent--tk-myriad-pro-semi-condensed--bWs1i";
export var whyUseAgent = "WhyUseAgent--whyUseAgent--IKvvH";
export var whyUseAgent__cta = "WhyUseAgent--whyUseAgent__cta--PS7Xu";
export var whyUseAgent__grid = "WhyUseAgent--whyUseAgent__grid--J4MCi";
export var whyUseAgent__icon = "WhyUseAgent--whyUseAgent__icon--s9D8I";
export var whyUseAgent__item = "WhyUseAgent--whyUseAgent__item--50kZo";
export var whyUseAgent__subtitle = "WhyUseAgent--whyUseAgent__subtitle--b8hky";
export var whyUseAgent__title = "WhyUseAgent--whyUseAgent__title--xwms-";